// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cross-sell-overview{display:grid;grid-gap:var(--spacing-xs);margin-bottom:var(--spacing-xl);margin-top:var(--spacing-lg)}@media screen and (min-width:769px){.cross-sell-overview{grid-gap:var(--spacing-sm);grid-template-columns:1fr;margin-bottom:var(--spacing-2xl);margin-top:var(--spacing-xl)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
